export default __webpack_public_path__ + "static/media/empty-states.d606c2a5.png";